import { createStyles, makeStyles } from '@material-ui/styles';
import themes from 'styles/themes';

export const useStyles = makeStyles(() =>
    createStyles({
        wrapper: {
            margin: 'auto',
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: 199,
        },
        main: {
            height: '100%',
        },
        checkoutButton: {
            textAlign: 'center',
            backgroundColor: 'white',
            position: 'absolute',
            bottom: '56px',
            width: '100%',
            left: 0,
            right: 0,
            padding: '0 32px',
            height: '56px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 56,
            '@media (max-width: 1024px)': {
                position: 'fixed',
            },
        },
        textCheckout: {
            color: themes.palette.primary.main,
            fontWeight: 600,
            fontSize: '14px',
            paddingRight: '11px',
        },
        popupClose: {
            height: 56,
            width: '100%',
        },
        popupMain: {
            backgroundColor: '#FFFFFF',
            padding: '0 24px 0 24px',
            borderRadius: '20px 20px 0px 0px',
        },
        popupContent: {
            height: 'auto',
            overflowY: 'scroll',
            maxHeight: '100%',
            paddingBottom: 120,
        },
        bagItem: {
            width: '100%',
            display: 'flex',
            padding: '20px 0 ',
            borderBottom: '1px solid #E8F0F1',
            fontFamily: 'PoppinsRegular',
        },
        itemImg: {
            borderRadius: '4px',
        },
        itemDetail: {
            flex: 1,
            paddingLeft: '10px',
            display: 'flex',
            flexDirection: 'column',
        },
        itemPrice: {
            flex: 1,
            color: themes.palette.primary.main,
            fontSize: 16,
            fontWeight: 600,
            lineHeight: '20px',
        },
        groupQuantity: {
            padding: '6px',
            border: '1px solid #4A6C72',
            borderRadius: '29px',
            display: 'flex',
        },
        group: {
            border: 'none',
            padding: '0  20px',
            borderRadius: '29px',
            display: 'flex',
            height: 32,
            background: themes.palette.primary.main,
            fontSize: 12,
            fontWeight: 600,
            fontFamily: 'PoppinsRegular',
            color: 'white',
            margin: 0,
            alignItems: 'center',
            justifyContent: 'center',
            width: 'auto',
        },
        itemQuantity: {
            color: themes.palette.primary.main,
            fontSize: 14,
            fontWeight: 400,
            lineHeight: '20px',
            padding: '0 12px',
        },
        itemName: {
            display: 'flex',
            justifyContent: 'space-between',
            paddingRight: '10px',
            color: themes.palette.primary.main,
            fontSize: 16,
            fontWeight: 600,
            lineHeight: '20px',
        },
        itemDes: {
            color: '#6D8B91',
            fontSize: 14,
            fontWeight: 400,
            opacity: 0.5,
            marginTop: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'column',
        },
        totalPrice: {
            fontWeight: 600,
            color: themes.palette.primary.main,
            fontSize: '16px',
            display: 'flex',
            justifyContent: 'space-between ',
            paddingTop: '20px',
            paddingBottom: '20px',
        },
        popupTitle: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '18px 10px 0 10px',
        },
        popupTitleText: {
            flex: 1,
            fontSize: 18,
            fontWeight: 500,
            color: themes.palette.primary.main,
            fontFamily: 'PoppinsRegular',
            margin: 0,
            textAlign: 'center',
        },
        popupTitleIcon: {
            color: themes.palette.primary.main,
        },
        popoverContainer: {
            padding: '10px 16px 6px 16px',
        },
        popoverText: {
            fontFamily: 'PoppinsRegular',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontsize: '14px',
            lineHeight: '20px',
            color: themes.palette.primary.main,
        },
        rootSelect: {
            fontSize: 14,
            color: themes.palette.primary.main,
        },
        outlineSelect: {
            padding: '0 10px',
        },
        itemDropdown: {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-between',
        },
    }),
);

export const dynamicLayoutStyles = makeStyles({
    itemPrice: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        fontFamily: 'Poppins',
        fontWeight: 400,
        fontSize: 10,
        padding: '2px 4px',
    },
    borderLeftNone: {
        borderLeft: 'none !important',
    },
    borderRightNone: {
        borderRight: 'none !important',
    },
    borderBottomNone: {
        borderBottom: 'none !important',
    },
    itemImage: {
        overflow: 'hidden',
        border: '1px solid #d7d7d7',
        cursor: 'pointer',
    },
    topLeftImage: {
        borderTopLeftRadius: 12,
    },
    bottomLeftImage: {
        borderBottomLeftRadius: 12,
    },
    topRightImage: {
        borderTopRightRadius: 12,
    },
    bottomRightImage: {
        borderBottomRightRadius: 12,
    },
    borderLeftBold: {
        borderLeft: '2px solid #d1d1d1',
    },
    borderRightBold: {
        borderRight: '2px solid #d1d1d1',
    },
    borderTopBold: {
        borderTop: '2px solid #d1d1d1',
    },
    borderBottomBold: {
        borderBottom: '2px solid #d1d1d1',
    },
});

export const dynamicLayoutItemDetailStyle = makeStyles({
    wrapper: {
        position: 'relative',
        height: '100%',
        width: '100%',
    },
    headerRightSide: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    closeIcon: {
        color: `black`,
        width: 20,
        marginLeft: 6,
    },
    itemImageWrapper: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    drawer: {
        height: '100%',
    },
});
